<template>
  <div>
    <div v-if="hasItem" class="info">
      <div class="logo">
        <img
            :alt="releaseItems[0].project.name"
            :src="getLogoSrc(releaseItems[0].project.icon)">
      </div>
      <div class="title">
        <span class="name">{{ releaseItems[0].project.name }}</span>
        <br>
        <span class="history">历史版本</span>
      </div>
    </div>
    <el-container v-loading="!hasItem" class="container custom-w">
      <div v-if="!hasItem" style="height: 50px;"></div>
      <el-card
          v-else
          v-for="item in releaseItems"
          :key="item.id"
          shadow="never"
          class="card item-w"
      >
        <div class="title" style="display: flex">
          <div style="display: flex">
            <span class="version">V{{ item.version }}</span>
          </div>
          <div class="btn">
            <el-button
                round
                size="mini"
                class="button"
                :style="`background: ${area === 'China' ? '#265CFD' : '#32C5FF'}`"
                @click="showDetail(item)"
            >
              <a>
                下载
              </a>
            </el-button>
          </div>
        </div>
        <ItemContext :item="item"/>
      </el-card>
    </el-container>

    <el-dialog
        :title="item.name"
        :visible.sync="dialogVisible"
        class="dialog"
    >
      <span slot="title">
        <DialogTitle :item="item"/>
      </span>
      <DialogBody :item="item"/>
      <span slot="footer">
        <DialogFooter :item="item"/>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import {getLogoSrc, getTagStyle, releaseItem} from "@/views/common/utils";
import ItemContext from "@/views/detail/ItemContext";
import DialogBody from "@/views/detail/DialogBody";
import DialogFooter from "@/views/detail/DialogFooter";
import DialogTitle from "@/views/detail/DialogTitle";

export default {
  name: 'Info',
  components: {ItemContext, DialogBody, DialogFooter, DialogTitle},
  props: {
    area: String,
  },
  data() {
    return {
      dialogVisible: false,
      item: {},
      getLogoSrc: getLogoSrc,
      getTagStyle: getTagStyle,
      url: '/package/release/',
      releaseItems: [releaseItem],
    }
  },
  methods: {
    fetch() {
      this.loading = true;
      this.$axios
          .get(
              this.url,
              {params: {project: this.$router.currentRoute.params.id, area: this.area}}
          )
          .then(
              response => {
                this.releaseItems = response.data.results;
              }
          )
      this.loading = false;
    },
    download(url) {
      window.location = url;
    },
    showDetail(item) {
      this.item = item;
      this.dialogVisible = true;
    },
  },
  mounted() {
    this.fetch();
  },
  computed: {
    hasItem() {
      try {
        return this.releaseItems[0].id;
      } catch {
        return false;
      }
    }
  },
}
</script>

<style lang="scss" scoped>

.info {
  display: flex;
  margin-top: 40px;
  padding-left: 12px;

  .logo {
    max-height: 60px;
    max-width: 60px;
    border-radius: 12px;
    overflow: hidden;

    img {
      max-height: 60px;
      max-width: 60px;
    }
  }

  .title {
    padding: 2px 0 0 16px;

    .name {
      line-height: 33px;
      height: 33px;
      font-size: 24px;
      color: #111111;
      margin-bottom: 2px;
      font-weight: bold;
    }

    .history {
      line-height: 22px;
      height: 22px;
      font-size: 16px;
      color: #999999;
    }
  }
}

.container {
  margin-top: 40px;
  height: auto;
  flex-wrap: wrap;

  .card {
    height: 260px;
    border-radius: 16px;
    background: #FFFFFF;
    margin: 0 12px 24px;
    border: 0;

    .title {
      height: 62.4px;
      box-shadow: inset 0 -1px 0 0 #EEEEEE;

      .version {
        margin: 16px 0 0 16px;
        height: 28px;
        font-size: 20px;
        color: #111111;
        font-weight: bold;
      }

      .btn {
        margin-left: auto;
        margin-right: 16px;

        .button {
          height: 30px;
          width: 60px;
          background: #265CFD;
          border-radius: 15px;
          color: white;
          border: 0;
          margin: 15px auto 0 0;

          a {
            color: white;
            text-decoration: none
          }

          span {
            height: 17px;
            font-size: 12px;
            color: #FFFFFF;
            text-align: center;
          }
        }
      }
    }

  }
}

@media (min-width: 375px) {
  .item-w {
    width: 335px;
  }

  .container {
    .card {
      width: 335px;
    }
  }
}

@media (min-width: 608px) {
  .item-w {
    width: 280px;
  }

  .container {
    .card {
      width: 280px;
    }
  }
}

/deep/ .el-dialog {
  border-radius: 15px;
}

/deep/ .el-dialog__body {
  padding: 10px 40px;
}

///deep/ .el-dialog__header {
//  padding: 24px 20px 24px 24px;
//  box-shadow: inset 0 -1px 0 0 #DDDDDD;
//}
</style>
